import { Text, Colors } from '@mercator-gcp/grout';

const betaTagStyle = {
  color: Colors.White,
  backgroundColor: Colors.ForestGreen900,
  borderRadius: '4px',
  paddingTop: 'padding_4',
  paddingBottom: 'padding_4',
  paddingLeft: 'padding_4',
  paddingRight: 'padding_4',
  display: 'inline-block',
};

const BetaTag = () => {
  return (
    <Text.SmallLabel as="div" sx={betaTagStyle}>
      Beta
    </Text.SmallLabel>
  );
};

export default BetaTag;
